import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Apartment from '../../../svg/Apartment.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';
import statesList from '../../../helpers/statesList.js';

class BillingAddress extends Component {
  state = {
    serviceAddress: {
      street_address: '',
      street_address_continued: '',
      city: '',
      state: '',
      zip_code: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { serviceAddress = {}, isCurrentStep } = this.state;
    const {
      street_address = '',
      street_address_continued = '',
      city = '',
      state = '',
      zip_code = ''
    } = serviceAddress;
    return (
      <React.Fragment>
        <InfoBox
          headline="Billing Address"
          subline="If different than your service address."
          icon={<Apartment />}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="street_address"
                placeholder="Address 1"
                type="text"
                value={street_address}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="street_address_continued"
                placeholder="Address 2 (optional)"
                type="text"
                value={street_address_continued}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="city"
                placeholder="City"
                type="text"
                value={city}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="onboarding-new__small-text-field">
              <FormsyInputMui
                name="state"
                placeholder="State"
                type="text"
                value={state}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
                validations={{
                  validateState: (values, value) => {
                    return this.isStateValid(value);
                  }
                }}
              />
            </div>
            <div className="onboarding-new__small-text-field">
              <FormsyInputMui
                name="zip_code"
                type="text"
                placeholder="Zip"
                value={zip_code}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
                validations={{
                  isNumeric: true,
                  isLength: 5
                }}
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    let { name, value } = e.target;

    if (name === 'zip_code') {
      // no non-digits allowed in zip_code
      if (isNaN(value)) return;
      if (value.length > 5) return;
    }

    if (name === 'state') {
      // limited to 2 letter abbreviations
      if (value.length > 2) return;
      value = value.toUpperCase();
    }

    this.setState({
      serviceAddress: { ...this.state.serviceAddress, [name]: value }
    });
  };

  handleClientUpdate = () => {
    const { serviceAddress } = this.state;

    // taking the address fields and adding to payment fields already submitted
    const updatedClient = {
      payment: this.mutatePayload(serviceAddress)
    };
    // console.log(updatedClient);
    this.props.updateClient(updatedClient);
  };

  mutatePayload = address => {
    const { payment } = this.props.client;

    return {
      ...payment,
      city: address.city,
      state: address.state,
      address: `${address.street_address}${
        address.street_address_continued
          ? ', ' + address.street_address_continued
          : ''
      }`,
      zip_code: address.zip_code
    };
  };

  isStateValid(str = '') {
    const upperCaseStr = str.toUpperCase();
    return statesList.indexOf(upperCaseStr) >= 0 ? true : false;
  }

  formatAddressFromPayment = payment => {
    const splitAddress = payment.address.split(', ');

    return {
      street_address: splitAddress[0],
      street_address_continued: splitAddress[1],
      city: payment.city,
      state: payment.state,
      zip_code: payment.zip_code
    };
  };

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;
    const { service_addresses = [], payment = {} } = client;

    if (prevProps.client !== client) {
      let serviceAddress;
      if (payment.address) {
        // if already added ingest fields and pre fill
        serviceAddress = this.formatAddressFromPayment(payment);
      } else if (!payment.address && service_addresses.length > 0) {
        // Otherwise start with service address
        serviceAddress = service_addresses[0];
      }
      this.setState({ serviceAddress });
    }

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }

  componentDidMount() {
    const { client } = this.props;
    const { service_addresses = [], payment = {} } = client;

    let serviceAddress;
    if (payment.address) {
      // if already added ingest fields and pre fill
      serviceAddress = this.formatAddressFromPayment(payment);
    } else if (!payment.address && service_addresses.length > 0) {
      // Otherwise start with service address
      serviceAddress = service_addresses[0];
    }
    this.setState({ serviceAddress });
  }
}

export default BillingAddress;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/BillingAddress.js